import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useGetLeadEvents, usePostLeadEvent } from '../../accountCreation';
import { clearTrainingProgress } from '../../training';
import { useRequestExternalValidation } from './useRequestExternalValidation';
import { useValidateIdentityNumber } from './useValidateIdentityNumber';
import { useRegistrationForm } from './useRegistrationForm';
import { useRegistrationPrefill } from './useRegistrationPrefill';
import { useRegistrationSubmit } from './useRegistrationSubmit';

export function useRegistration() {
  const { t } = useTranslation(['onboarding']);
  const navigate = useNavigate();

  useEffect(() => {
    clearTrainingProgress();
  }, []);

  const { control, handleSubmit, setError, setValue, clearErrors, formState } =
    useRegistrationForm(t);

  const validateIdentityMutation = useValidateIdentityNumber();
  const { data: leadEvents = [] } = useGetLeadEvents();
  const postLeadEventMutation = usePostLeadEvent({
    invalidateEventsOnSuccess: false,
    mergeEventIntoCacheOnSuccess: false,
    suppressDefaultErrorToast: true,
  });
  const requestExternalValidationMutation = useRequestExternalValidation({
    invalidateEventsOnSuccess: false,
  });

  useRegistrationPrefill({
    leadEvents,
    setValue,
  });

  const {
    onSubmit,
    isSubmitting,
    hasPersonalDetailsStage,
    showSuccessModal,
    handleDismissSuccessModal,
    submitError,
  } = useRegistrationSubmit({
    t,
    navigate,
    leadEvents,
    clearErrors,
    setError,
    validateIdentityMutation,
    postLeadEventMutation,
    requestExternalValidationMutation,
  });

  return {
    control,
    handleSubmit,
    formState,
    isSubmitting,
    hasPersonalDetailsStage,
    showSuccessModal,
    handleDismissSuccessModal,
    onSubmit,
    submitError,
  };
}
